"use client"

import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { Col, Row, Skeleton } from "antd"

const ProductPreviewSkeleton = () => {
  const isDesktop = useIsDesktop()

  return (
    <Row style={{ height: '100%' }}>
      <Col span={24}>
        <Skeleton.Image
          active
          styles={isDesktop ? {
            root: {
              width: '100%',
              height: '100%',
              maxHeight: 'calc(100vh - 6.4rem)'
            },
            content: {
              width: '100%',
              height: '100%'
            }
          } : {
            root: {
              width: 'calc(100vw - 2rem)',
              height: `calc(${100 / 0.8}vw - 2rem)`
            },
            content: {
              width: '100%',
              height: '100%'
            }
          }}
        />
      </Col>
    </Row>
  )
}

export default ProductPreviewSkeleton